import React, { useEffect, useState } from 'react';
import styles from '../../businessAssetsPage.module.css';
import { Icon, SortableList, Text } from '@bloobirds-it/flamingo-ui';
import { SearchLogs } from '../../../../../../assets/svg';
import { headerNames } from './buyerPersonasList.constants';
import {
  EntityHeaderItem,
  EntityList,
  EntityListHeader,
} from '../../../../../components/entityList/entityList';
import { BuyerPersonaCard } from './buyerPersonaCard/buyerPersonaCard';
import { useBuyerPersonasList } from '../../../../../hooks/useBuyerPersonasList';
import { EntityCard } from '../../../../../components/entityList/entityCard/entityCard';
import { mutate } from 'swr';
import { useOrdering } from '../../../../../hooks/useOrdering';

export const BuyerPersonasList = ({ searchValue, setShowExamplePage }) => {
  const { buyerPersonas } = useBuyerPersonasList();
  const { parseOrderingRequest, handleUpdateOrdering } = useOrdering();
  const [buyerPersonasList, setBuyerPersonasList] = useState(buyerPersonas);
  useEffect(() => {
    if (searchValue) {
      const filteredList = buyerPersonas.filter(buyerPersona =>
        buyerPersona.name.toLowerCase().includes(searchValue.toLowerCase()),
      );
      setBuyerPersonasList(filteredList);
    } else {
      setBuyerPersonasList(buyerPersonas);
    }
  }, [searchValue, buyerPersonas]);

  return (
    <>
      {buyerPersonas?.length > 0 ? (
        <EntityList>
          {buyerPersonasList?.length > 0 ? (
            <>
              <EntityListHeader>
                <EntityHeaderItem />
                {headerNames.map(name => (
                  <EntityHeaderItem label={name?.label} key={name?.label} />
                ))}
              </EntityListHeader>
              <SortableList
                className={styles._tbody}
                onReorder={v => {
                  setBuyerPersonasList(v);
                  const newOrdering = parseOrderingRequest({ list: v, takeIndex: true });
                  handleUpdateOrdering({
                    list: newOrdering,
                    entityName: 'idealCustomerProfiles',
                    callback: () => {
                      mutate('/idealCustomerProfiles');
                    },
                  });
                }}
                disabled={searchValue?.length > 0}
                data={buyerPersonasList}
                keyExtractor={sc => sc?.id}
                renderItem={({ item: icp, innerRef, containerProps, handleProps, isDragging }) => (
                  <EntityCard
                    ref={innerRef}
                    {...containerProps}
                    {...handleProps}
                    className={isDragging && styles._card__dragging}
                  >
                    <BuyerPersonaCard icp={icp} />
                  </EntityCard>
                )}
              />
            </>
          ) : (
            <div className={styles._no_results__contents}>
              <SearchLogs className={styles._no_results__img} />
              <Text size="xl" weight="bold" align="center" color="softPeanut">
                No Buyer Personas for the following search
              </Text>
            </div>
          )}
        </EntityList>
      ) : (
        <div className={styles._no_results__contents}>
          <SearchLogs className={styles._no_results__img} />
          <Text size="xl" weight="bold" align="center" color="softPeanut">
            Still no Buyer Personas have been created
          </Text>
          <Text size="m" align="center" weight="regular" color="softPeanut">
            See how setting up your playbook correctly can help you in your sales process! See some
            examples to inspire you, then click the Create Target Market button to get started.
          </Text>
          <span onClick={() => setShowExamplePage(true)}>
            <Icon name="eye" color="purple" size={16} />
            <Text htmlTag="span" size="xs" color="purple" className={styles._link}>
              See some examples
            </Text>
          </span>
        </div>
      )}
    </>
  );
};
